<template>
    <div class="login-container">
        <h6 class="d-block align-center">
            <img src="static/icon/icon-logo@64px.png">
        </h6>
        <h2 class="d-block align-center ptb-lg c-white">陆航飞行数据中心</h2>
        <Card>
            <Form :model="loginData">
                <Divider>
                    <strong>登录</strong>
                </Divider>
                <div class="d-block">
                    <FormItem>
                        <Input type="text" prefix="md-contact" v-model="loginData.account" placeholder="..."/>
                    </FormItem>
                    <FormItem>
                        <Input type="password" prefix="md-lock" password v-model="loginData.password" placeholder="..."/>
                    </FormItem>
                </div>
            </Form>
            <Button type="primary" long @click="submitLogin">登陆</Button>
            <p class="pt-lg align-center">
                <router-link to="">忘记密码？</router-link>
            </p>
        </Card>
    </div>
</template>

<script type="text/javascript">
    export default {
        data () {
            return {
                loginData: {
                    user: 'user',
                    account: '13000000000',
                    password: '123456'
                },
                captchaBtn: '获取验证码',
                captchaCount: '',
                captchaTimer: null,
            }
        },
        mounted() {
        },
        methods: {
            // 验证码 倒计时
            getCaptcha(){
                const time = 60;
                if (!this.captchaTimer) {
                    this.captchaCount = time;
                    this.captchaTimer = setInterval(() => {
                        if (this.captchaCount > 0 && this.captchaCount <= time) {
                            this.captchaCount--;
                            this.captchaBtn = "重新发送(" + this.captchaCount + ")";
                        } else {
                            clearInterval(this.captchaTimer);
                            this.captchaTimer = null;
                        }
                    }, 1000);
                    this.$Message.success('验证码发送成功');
                }
            },
            submitLogin(){
                if (this.verifyLogin() === true){
                    localStorage.setItem('accountData', JSON.stringify(this.loginData));
                    this.$Message.success('登陆成功');
                    window.location.href = '/';
                }
            },
            verifyLogin(){
                // if (this.loginData.account === ''){
                //     this.$Message.error('账户不能为空');
                //     return false;
                // } else if (this.loginData.password === '') {
                //     this.$Message.error('密码不能为空');
                //     return false;
                // } else if (this.loginData.account !== 0 || this.loginData.password !== 123456) {
                //     this.$Message.error('账户 & 密码错误');
                //     return false;
                // } else {
                //     return true;
                // }
                return true;
            },
            toggleLoginType(){
                this.defaultLogin = !this.defaultLogin;
                this.captchaLogin = !this.captchaLogin;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/login.vue